import bindAll from 'lodash.bindall';
import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';
import { handleLinkRobot } from '../lib/get-Link-fn.js';

/**
 * Turbo Mode component passes toggleTurboMode function to its child.
 * It also includes `turboMode` in the props passed to the children.
 * It expects this child to be a function with the signature
 *     function (toggleTurboMode, {turboMode, ...props}) {}
 * The component can then be used to attach turbo mode setting functionality
 * to any other component:
 *
 * <TurboMode>{(toggleTurboMode, props) => (
 *     <MyCoolComponent
 *         turboEnabled={props.turboMode}
 *         onClick={toggleTurboMode}
 *         {...props}
 *     />
 * )}</TurboMode>
 */
let portArr = [];
class GetSerialPort extends React.Component {
    constructor (props) {
        super(props);
        bindAll(this, [
            'getSerialPort'
        ]);
    }

    getSerialPort () {
        handleLinkRobot(this.props.vm.robotType)
    }
    componentDidMount () {
        const self = this;

        this._onBlurHandler(self);
    }
    // 点击非目标区域隐藏目标区域（弹出的菜单）
    _onBlurHandler (self) {
        document.body.addEventListener('click', function (e) {
            document.getElementsByClassName('menu-bar_portBox_x87xi')[0].style.display = 'none';
        }, false);
    }
    render () {
        const {
            /* eslint-disable no-unused-vars */
            children,
            vm,
            /* eslint-enable no-unused-vars */
            ...props
        } = this.props;
        return this.props.children(this.getSerialPort, props);
    }
}

GetSerialPort.propTypes = {
    children: PropTypes.func,
    turboMode: PropTypes.bool,
    vm: PropTypes.shape({
        setTurboMode: PropTypes.func
    })
};

const mapStateToProps = state => ({
    vm: state.scratchGui.vm,
    turboMode: state.scratchGui.vmStatus.turbo
});

export default connect(
    mapStateToProps,
    () => ({}) // omit dispatch prop
)(GetSerialPort);
